import { tr } from './tr';

export { tr };

export type MessageKey = keyof typeof tr;

/**
 * Metin al. Parametreler `{ad}` biçiminde yer tutuculara yazılır.
 * Kullanıcıya görünen hiçbir metin koda gömülmez; hepsi `tr.ts` içindedir.
 */
export function t(key: MessageKey, params?: Record<string, string | number>): string {
  let s: string = tr[key];
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      s = s.replaceAll(`{${k}}`, String(v));
    }
  }
  return s;
}
